<template>
<!--  <h2>دسته بندی ها</h2>-->
  <div class="col-6 float-right cat" v-for="(cat, index)  in category.data" :key="index" @click="setCategory(cat.id,cat.title)">
    <template  v-if="cat.pic!=''">

      <div class="catItem" :style="'background: url('+cat.img_url+')'">

        <h3 v-text="cat.title"></h3>
      </div>
    </template>

  </div>

</template>

<script>
import http from "@/plugins/axios";
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

// Import Swiper styles
import 'swiper/css';
import router from "@/router";
export default {
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  name: 'category',
  data: () =>({
    category :  {
      data: [],
    },
  }),
  methods: {
    getPicLink() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/category", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.category = response.data;
          })
          .catch((error) => {
          });
    },
    setCategory(id,category){
        router.push("/products/"+id+"/"+category)
    }
  },
  mounted() {
    this.getPicLink();
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
}
</script>

<style scoped>
.catItem{
  width: 90%;background: #e7e7e7;border-radius: 10px;
  overflow: hidden;
  font-family: iranyekan !important;
  min-height: 165px;

}
h2{
  text-align: center;
  margin: 10px auto;
  width: 200px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  font-family: iranyekan !important;

}
h3{
  text-align: center;
  padding: 10px 0;
  font-family: iranyekan !important;
  background: rgba(255,255,255,0.85);
  margin-top: -1px;

}
.cat:hover h3{
  display: block;
}
.cat:hover img{
  opacity: 0.5;
}
.cat img{
  margin: 0 auto;
}
.cat{
  margin: auto -5px;
  padding: 5px;
  position: relative;
}

</style>